export default {
  api: {
    emailAddress: {
      email: {
        notNull: "Provide an email address.",
        invalid: "Invalid email address.",
      },
      type: {
        notNull: "Select a email address type",
        found: "Type of email address already exists",
      },
    }
  },
}
